module.exports = __webpack_public_path__ + "img/top3head@2x.78e7030a.png";